

import Vue from 'vue'
import FastClick from 'fastclick'
import store from './store/index.js';
import VueRouter from 'vue-router'
import App from './App'


import router from './router/index.js' 
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'






import Es6Promise from 'es6-promise';
import utils, { getCookie, setCookie} from './common/js/utils.js';
import http from './common/js/http.js';

Es6Promise.polyfill()


Vue.use(VueRouter)
Vue.use(WechatPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)










FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.prototype.$config = {
partnerId:'',
platform: ''
};



Vue.prototype.$http = http;


Vue.use(utils);

router.beforeEach(function (to, from, next) {
/* 路由发生变化修改页面title */



setCookie("homeH5", 0)
setCookie('miniprogram', 0)
setCookie("partnerId", '')


if (/MicroMessenger/.test(window.navigator.userAgent) && window.location.href.indexOf('://qr') > -1) {

let href = window.location.href

let currentHref = href.replace('://qr','://wx')
console.log(currentHref)
window.location.href = currentHref
} else if (/AlipayClient/.test(window.navigator.userAgent) && window.location.href.indexOf('://qr') > -1) {

let href = window.location.href

let currentHref = href.replace('://qr','://zfb')
window.location.href = currentHref
}

let user = getCookie('user')


const redirect = getCookie('redirect')
const yueredirect = getCookie('yueredirect')
if(to.name=="yueIndex" || to.name == "yueOouyanMini" || ( to.name!=null && to.name.indexOf('yue') > -1) || ( from.name!=null && from.name.indexOf('yue') > -1 ) ||
(to.path == "/loginSuccess" && redirect!=null && ( redirect.indexOf('/#/yue') > -1) ) ||
(to.path == "/loginSuccess" && yueredirect!=null && ( yueredirect.indexOf('/#/yue') > -1) )
) {
Vue.prototype.$config.platform = 'yuexiu'
}

if (user) {
user = JSON.parse(user);
if (user.phoneCertification == 0 && (
to.path != '/mobileAuth' &&
to.path != '/failure' &&
to.path != '/main' &&
to.path != '/linkCustomerService' &&
to.path != '/follow')) {
router.replace({ path: '/mobileAuth' });
}
}


if (Vue.prototype.$config.platform != 'yuexiu') {
if (to.meta.title) {
document.title = to.meta.title
}
if (to.name == "Home") {
document.title = '闲置衣物回收'
}

if (to.name == "Home") {
if (to.query.partnerId) {
to.meta.partnerId = to.query.partnerId
Vue.prototype.$config.platform = 'partner'
Vue.prototype.$config.partnerId = to.query.partnerId
} else {
Vue.prototype.$config.platform = 'homeH5'
}
}  else if (to.name == "Appointment") {
Vue.prototype.$config.platform = (to.query.miniprogram == '1' || to.query.miniprogram == 1)? 'miniprogram': 'appointmentH5'
} else{
Vue.prototype.$config.platform = 'appointmentH5'
}
}
if (to.meta.title) {
document.title = to.meta.title
}
next()
})

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js